/* eslint semi: 1 */
import _ from 'lodash';

export default {
  name: 'bezels-mask',
  props: {
    bezels: {
      type: Array,
      required: true
    },
    resolutionWidth: Number,
    resolutionHeight: Number,
    cardWidth: Number,
    cardHeight: Number,
    fadeColor: Boolean
  },
  computed: {
    rectangles () {
      if (!_.isArray(this.bezels) || !this.resolutionWidth || !this.resolutionHeight || !this.cardWidth || !this.cardHeight) {
        return [];
      }

      return this.bezels.map((rect, i) => {
        const coefficientHorizontal = this.cardWidth / this.resolutionWidth;
        const coefficientVertical = this.cardHeight / this.resolutionHeight;

        return {
          top: Math.round(rect.y * coefficientVertical),
          left: Math.round(rect.x * coefficientHorizontal),
          width: Math.ceil(rect.width * coefficientHorizontal),
          height: Math.ceil(rect.height * coefficientVertical)
        };
      });
    }
  }
};
